<template>
  <div class="hire">
    <Nav />
    <div class="pt-5 mt-5"></div>
    <div class="mt-5 px-2">
      <a-steps
        v-model="current"
        type="navigation"
        :style="stepStyle"
        v-if="current < 10"
        class="steps"
        size="small"
      >
        <a-step :status="status(1)" title />
        <a-step :status="status(2)" title />
        <a-step :status="status(3)" title />
        <a-step :status="status(4)" title />
        <a-step :status="status(5)" title />
        <a-step :status="status(6)" title />
        <a-step :status="status(7)" title />
        <a-step :status="status(8)" title />
        <a-step :status="status(9)" title />
      </a-steps>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";

export default {
  name: "hire",
  components: {
    Nav
  },
  data: () => ({
    current: 1,
    stepStyle: {
      marginBottom: "20px"
      // boxShadow: '0px -1px 0 0 #e8e8e8 inset',
    }
  }),
  computed: {
    isLoggedIn: () => {
      return this.$store.getters.isLoggedIn;
    }
  },
  methods: {
    status(number) {
      return this.current === number
        ? "process"
        : this.current > number
        ? "finish"
        : "wait";
    },
    getCurrent() {
      const { path } = this.$route;

      this.current = path.includes("/job-bio")
        ? 9
        : path.includes("company-bio")
        ? 8
        : path.includes("job-salary")
        ? 7
        : path.includes("job-expert-level")
        ? 6
        : path.includes("job-work-hour")
        ? 5
        : path.includes("job-duration")
        ? 4
        : path.includes("/job-stack")
        ? 3
        : path.includes("/job-post")
        ? 2
        : 1;
    }
  },
  mounted() {
    this.getCurrent();
  },
  updated() {
    this.getCurrent();
  }
};
</script>

<style scoped>
p,
li,
span {
  font-size: 12px;
}

.steps {
  width: 70%;
  margin: 0 auto 15px;
}

.steps >>> .ant-steps-item.ant-steps-item-finish .ant-steps-item-icon {
  line-height: 23px;
}

.steps >>> .ant-steps-item-process .ant-steps-item-icon {
  background-color: #06216d;
  border-color: #06216d;
}
/* .steps .ant-steps-item-process .ant-steps-item-icon {
  background-color: #20409a !important;
  border-color: #20409a !important;
} */
</style>
